import React from 'react';
import { Box, Button as MuiButton, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLocationSearch } from '../../helpers/hooks/useLocationSearch';

interface ConfirmationWithBackButtonType {
  icon?: string;
  title: string;
  subtitle: string;
  image?: string;
  message?: string | React.ReactNode;
  bottomMessage?: string | React.ReactNode;
  goBackLink?: string;
}

const ConfirmationWithBackButton = ({
  icon,
  title,
  subtitle,
  image,
  message,
  bottomMessage,
  goBackLink,
}: ConfirmationWithBackButtonType) => {
  const history = useNavigate();
  const getUrlWithQueryParams = useLocationSearch();
  const handleBackClick = (url: string) => {
    history(getUrlWithQueryParams(url));
  };

  return (
    <div
      style={{
        position: 'relative',
        height: 'auto',
        minHeight: '830px',
      }}
    >
      {icon && (
        <Box display="flex" justifyContent="center" marginBottom={3}>
          <img
            className="image"
            src={icon}
            alt=""
            width="50px"
            height="50px"
            style={{ display: 'block' }}
          />
        </Box>
      )}

      <Grid
        container={true}
        justifyContent="center"
        alignItems="center"
        spacing={1}
        paddingX={5}
        textAlign="center"
      >
        <Grid item={true} xs={12}>
          <Box maxWidth="730px" margin="auto">
            <Typography variant="h2" fontFamily="Ivar Display">
              {title.split('<br>').map((elt) => (
                <div key={elt}>
                  {elt}
                  <br/>
                </div>
              ))}
            </Typography>

            <Box mb={1}/>

            <Typography variant="body1">{subtitle}</Typography>
          </Box>
        </Grid>

        {image && (
          <Grid item={true} xs={12} md={10} lg={9}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ bottom: 0 }}
              width="100%"
            >
              <Box
                height="100%"
                width={{ xs: '100vw', md: '80vh' }}
                minWidth={{ md: 350 }}
                maxWidth={{ md: 505 }}
              >
                <img
                  alt="compliance"
                  src={image}
                  width="100%"
                  height="100%"
                  style={{ display: 'block' }}
                />
              </Box>
            </Box>
          </Grid>
        )}

        {message && (
          <Grid item={true} xs={12} md={10} lg={9}>
            {message}
          </Grid>
        )}

        <Grid item xs={12} md={10} lg={9} mt={4}>
          <MuiButton
            variant="contained"
            onClick={() =>
              goBackLink ? handleBackClick(goBackLink) : history(-1)
            }
            sx={{ width: { xs: '100%', sm: 'auto' } }}
          >
            Go Back
          </MuiButton>
        </Grid>

        {bottomMessage && (
          <Grid item={true} xs={12} md={10} lg={9}>
            {bottomMessage}
          </Grid>
        )}

      </Grid>
    </div>
  );
};

export default ConfirmationWithBackButton;
